import { Separator } from '@/shadcn/components/ui/separator';
import { cn } from '@/shadcn/lib/utils';

type ListingDetailSectionProps = {
    title: string;
    children: React.ReactNode;
    className?: string;
    contentClassName?: string;
    withSeparator?: boolean;
};

export function ListingDetailSection({
    title,
    children,
    className,
    contentClassName,
    withSeparator = true,
}: ListingDetailSectionProps) {
    return (
        <>
            {withSeparator && <Separator className="my-[30px]" />}

            <section className={className}>
                <h2 className="font-[700] text-[18px] md:text-[19px] xl:text-[20px]">{title}</h2>

                <div className={cn('mt-[20px]', contentClassName)}>{children}</div>
            </section>
        </>
    );
}
